<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Warning!</h4>
</div>
<div class="modal-body pb-0" hsDraggable="modal-dialog">
  <p>
    By turning this setting on you acknowledge that you are aware of the
    inherent risks of complex processes that require sorting in bulk dialogs,
    mainly related to, but not limited to, sorting your dataset incorrectly and
    pasting values into the wrong rows.
  </p>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button
    nf-button="save"
    (click)="activeModal.close()"
    aria-label="Acknowledge Button"
  >
    Acknowledge
  </button>
  <button
    nf-button
    ngbAutoFocus
    (click)="activeModal.dismiss()"
    aria-label="Cancel Button"
  >
    Cancel
  </button>
</div>
